


<template>
    <div class="home-slider">
        <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="4000"
                controls
                indicators
                background="#ababab"
                img-width="1024"
                img-height="480"
                style="text-shadow: 1px 1px 2px #333;"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
        >
            <b-carousel-slide
                    v-for="banner in bannerData"
                    :key="banner.id"
                    :caption-html="banner.sub_heading"
                    :text-html="banner.caption"
            >
                <img
                        slot="img"
                        class="d-block img-fluid w-100"
                        width="1024"
                        height="480"
                        :src="banner.image"
                        alt="image slot"
                        v-on:click="navigateTo(banner.link)"
                >
            </b-carousel-slide>



        </b-carousel>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                slide: 0,
                sliding: null
            }
        },
        props: ['banners'],
        methods: {
            onSlideStart(slide) {
                this.sliding = true
            },
            onSlideEnd(slide) {
                this.sliding = false
            },
            navigateTo(link) {
                window.location.href = link;
            }
        },
        computed: {
            bannerData() {
                return JSON.parse(this.banners);
            }
        },
    }
</script>
